import React from 'react'
import ReactDOM from 'react-dom';


import {
    BrowserRouter as Router,
    Switch,
    Routes,
    Route,
    useLocation
  } from "react-router-dom";

import {Provider} from 'react-redux'
import {createStore, applyMiddleware, compose} from 'redux'
import thunk from 'redux-thunk'
import reducers from './reducers'


import { createTheme} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import App from './App'
import './index.css'
import { NotificationProvider } from './v2/notifications/NotificationManager.js';
import NotificationContainer from './v2/notifications/NotificationContainer.js';
import { useTheme, ThemeProvider as MyThemeProvider } from './ThemeContext.js';

const store = createStore(reducers, compose(applyMiddleware(thunk)))

/*const theme = createTheme({
  palette: {
    primary: {
      main: '#3b3b3b',
      darkgrey: '#595959',
      blue: '#1777b7',
      green: '#02bd92',
      red: '#e46567',
    },
    multiplex : {
      main : '#47464B',
      grey : '#6D6E73',
      lightgrey : '#E5E7E9',
      darkblue : '#4A5168',
      classement : '#458BCA',
      chrono : '#018C38',
      mitemps : '#E7401E',
      forfait : '#47464B',
      reported : '#969696'
    },
    media : {
      main : '#47464B',
      darkgrey : '#6d6e73',
      lightgrey : '#e5e7e9',
      darkblue : '#4a5168',
      blue : '#4a587c',
      green : '#5cae31',
      red : '#e05b37'
    },
    quizzdarkblue : {
      main : '#4a5168'
    },
    quizzgreen : {
      main : '#5cae31'
    },
    quizzred : {
      main : '#e05b37'
    },
    background: {
      default: 'white',
    },
    text: {
      primary: '#3b3b3b',
    },
  },
})

theme.typography.h4 = {
  fontSize: '1.2rem',
  '@media (min-width:600px)': {
    fontSize: '1.5rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '2.4rem',
  },
};

theme.typography.h5 = {
  fontSize: '1rem',
  '@media (min-width:600px)': {
    fontSize: '1.3rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '2rem',
  },
};

theme.typography.body2 = {
  fontSize: '0.8rem',
  '@media (min-width:600px)': {
    fontSize: '1rem',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '1rem',
  },
};*/



const Root = () => {
  const { theme } = useTheme();

  return (
      <ThemeProvider theme={theme}>
          <Router>
            <NotificationProvider>
              <App />
              <NotificationContainer />
            </NotificationProvider>
          </Router> 
        </ThemeProvider>
  )
}

ReactDOM.render(
    

    <Provider store={store}>
      <MyThemeProvider>
        <Root/>
      </MyThemeProvider>
    </Provider>, 
    document.getElementById('root'));